import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
    SystemVersion: any;
    WhiteLabel: boolean;//Added By Ketan on 21-Oct-2020
    constructor(
        private cookieService: CookieService,
        private decryptpipe: DecryptPipe
    ) {
    }
    ngOnInit() {

        //Added By Ketan on 21-Oct-2020
        this.WhiteLabel = JSON.parse(localStorage.getItem('whitelabelFlag'));
        //  ;
        console.log('WhiteLabel', this.WhiteLabel);
        if (this.WhiteLabel == false) {
            $("#WhiteLabel").show()
        }
        else {
            $("#WhiteLabel").hide()
        }
        //Ended By Ketan on 21 - Oct - 2020

        this.SystemVersion = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SystemVersion")));
    }



}